import React from 'react';

import { DateTime } from 'luxon';

import { Order, Region } from '@admin/schema';

export const Scheduled: React.FC<{
  order: Pick<Order, 'scheduled'> & { region: Pick<Region, 'tz'> };
}> = ({ order }) => {
  const scheduled = DateTime.fromISO(order.scheduled, { zone: order.region.tz });

  return (
    <>
      {scheduled.toFormat('LLL d, yyyy, h:mm a')} {scheduled.toFormat('ZZZZ')}
    </>
  );
};
